import { request } from "../request";


/**
 * 获取产品列表
 */
export function fetchGetProductListForUserAsync(onlyAiEnabled?: boolean) {
  return request<(DB.Product & {
    CurrentAmount: number
  })[]>({
    url: '/Product/GetProductListForUser',
    method: 'get',
    params: {
      onlyAiEnabled
    }
  });
}


export type InputGetProductListQueryFilter = {
  /**
   * 币种名称
   */
  Bcdn?: string;
  /**
   * 产品代码
   */
  ProductCode?: string;
};


export function fetchGetProductList(page: number, pageSize: number, input: InputGetProductListQueryFilter) {
  return request<{
    total: number,
    list: DB.Product[]
  }>({
    url: '/Product/GetProductList',
    method: 'post',
    params: {
      page,
      pageSize
    },
    data: input
  });
}

export type InputSetProductStatus = {
  Id: number;
  Status: boolean
};

export function fetchSetProductStatus(input: InputSetProductStatus) {
  return request<{
    Status: boolean
  }>({
    url: '/Product/SetProductStatus',
    method: 'post',
    data: input
  });
}


export type InputSetProductAiOrderEnabled = {
  Id: number;
  Open: boolean
};

/**
 * 是否开启AI
 * @param input
 * @returns
 */
export function fetchSetProductAiOrderEnabled(input: InputSetProductAiOrderEnabled) {
  return request<{
    Status: boolean
  }>({
    url: '/Product/SetProductAiOrderEnabled',
    method: 'post',
    data: input
  });
}

export type InputAddProduct = {
  Bcdn?: string;
  IconUrl?: string;
  Status?: boolean;
  AiOrderEnabled?: boolean;
  MinVolatility?: number;
  MaxVolatility?: number;
  RandomVolatilityRange?: number;
  Spread?: number;
  SortOrder?: number;
  LeverageMultiplier?: string;
  TimeIntervalRule?: string;
};
/**
 * 创建产品
 * @param input
 * @returns
 */
export function fetchAddProduct(input: InputAddProduct) {
  return request({
    url: '/product/AddProduct',
    method: 'post',
    data: input
  })
}

export type InputUpdateProduct = {
  Id?: number;
} & InputAddProduct;

/**
 * 修改产品
 * @param input
 * @returns
 */
export function fetchUpdateProduct(input: InputUpdateProduct) {
  return request({
    url: '/product/UpdateProduct',
    method: 'post',
    data: input
  })
}

export type InputGetAutoCompleteProduct = {
  Dn: string;
};

/**
 * 获取自动补全产品列表
 * @param input
 * @returns
 */
export function fetchGetAutoCompleteProductListAsync(input: InputGetAutoCompleteProduct) {
  return request<{
    Id: number,
    Dn: string,
    IconUrl: string
  }[]>({
    url: '/product/GetAutoCompleteProductList',
    method: 'post',
    data: input
  })
}

/**
 * 根据产品编码获取产品数据
 */
export function fetchGetProductDataForUserAsync(productCode: string) {
  return request<DB.Product>({
    url: '/product/GetProductDataForUser',
    method: 'get',
    params: {
      productCode
    }
  })
}


